import { render, staticRenderFns } from "./SellerStatisticsView.vue?vue&type=template&id=b59b2b8c&"
import script from "./SellerStatisticsView.vue?vue&type=script&lang=js&"
export * from "./SellerStatisticsView.vue?vue&type=script&lang=js&"
import style0 from "./SellerStatisticsView.vue?vue&type=style&index=0&id=b59b2b8c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports